import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "column" }
const _hoisted_2 = { class: "row items-center no-wrap q-gutter-xs" }
const _hoisted_3 = ["onClick"]

import { computed, onMounted, reactive, ref, watch } from 'vue';

import FieldFileSigningActions from 'SharedComponents/Fields/FieldFileSigningActions.vue';
import { BaseFieldEmits } from 'SharedComponents/Fields/composables/useBaseFieldProps';
import { ViewFieldProps } from 'SharedComponents/Fields/composables/useViewField';
import useFileApi from 'SharedDir/common/composables/useFileApi';
import { makeRequest } from 'SharedDir/common/composables/useRequests';
import { FieldFile } from 'SharedDir/declarations/fields';
import { NotNull } from 'SharedDir/declarations/shared';
import { MakeDictionary } from 'SharedDir/utils/helpers';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'FileSetValue' },
  __name: 'FileSetValue',
  props: {
    modelValue: {},
    label: {},
    showHistory: { type: Boolean },
    history: {}
  },
  emits: ["reveal-history"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emits = __emit;
const file = computed(() => props.modelValue || null);
const { downloadFile } = useFileApi();

let filesLoading = reactive<Record<string, boolean>>({});
const download = (fileId: string) => {
  makeRequest(() => downloadFile(fileId), {
    startLoading: () => {
      filesLoading[fileId] = true;
    },
    finishLoading: () => {
      filesLoading[fileId] = false;
    },
  });
};

const refreshLoaders = (files: NotNull<FieldFile>[]) => {
  const newDict = MakeDictionary(files ?? [], 'fileId', 'value');
  filesLoading = Object.fromEntries(Object.entries(newDict).map(([id]) => [id, false]));
};

const files = computed(() => props.modelValue.value || []);

watch(
  () => props.modelValue,
  ({ value: newFiles }) => {
    refreshLoaders(newFiles);
  }
);

onMounted(() => {
  refreshLoaders(props.modelValue.value);
});

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("figure", _hoisted_1, [
    _createElementVNode("figcaption", null, _toDisplayString(_ctx.label), 1),
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (fileItem) => {
        return (_openBlock(), _createElementBlock("li", {
          key: fileItem.fileId
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", {
              class: "s-link",
              onClick: ($event: any) => (fileItem.fileId && download(fileItem.fileId))
            }, [
              _createVNode(_component_q_icon, {
                size: "1.5em",
                name: "attachment",
                class: _normalizeClass({ shaking: _unref(filesLoading)[fileItem.fileId] })
              }, null, 8, ["class"]),
              _createTextVNode(" " + _toDisplayString(fileItem.value), 1)
            ], 8, _hoisted_3),
            (fileItem.fileId)
              ? (_openBlock(), _createBlock(FieldFileSigningActions, {
                  key: 0,
                  "file-id": fileItem.fileId,
                  "file-name": fileItem.value || ''
                }, null, 8, ["file-id", "file-name"]))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})